// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"447":"32e0ca305657f90322e0","925":"ce04b79dd001e00c3267"}[chunkId] + ".js";
};